export const STATIC_TEXTS_CONSTS = {
    GET_STATIC_TEXTS: "GET_STATIC_TEXTS",
    UPDATE_STATIC_TEXTS: "UPDATE_STATIC_TEXTS",
};